var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-tree-select',{staticStyle:{"width":"100%"},attrs:{"disabled":_vm.disabled,"placeholder":_vm.placeholder,"dropdown-style":{ maxHeight: '400px', overflow: 'auto' },"tree-data":_vm.department_tree,"tree-default-expand-all":"","replaceFields":{
    label: 'department_name',
    children: 'children',
    value: 'department_id',
    key: 'department_id',
  },"allowClear":_vm.allowClear},on:{"change":_vm.handleChange},model:{value:(_vm.internalValue),callback:function ($$v) {_vm.internalValue=$$v},expression:"internalValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }